import { render, staticRenderFns } from "./VSnackbars.vue?vue&type=template&id=9d4dc0d6&"
import script from "./VSnackbars.vue?vue&type=script&lang=js&"
export * from "./VSnackbars.vue?vue&type=script&lang=js&"
import style0 from "./VSnackbars.vue?vue&type=style&index=0&id=9d4dc0d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports